import React from "react";
import styles from "../PlanCard.module.css";
import { Badge } from "@shopify/polaris";

const InfoBadge = ({ text }) => {

  return (
    <div className={styles.yearlyBadgeWrapper}>
      <Badge>{text}</Badge>
    </div>
  );
};

export default InfoBadge;